// https://www.showdoc.cc/2087618245071777
// yASXwxSY

// /data/www/netime/440me


const host = '/api/';

export default {
    nav: `${host}goods-category`,   //导航
    home: `${host}index`,           //首页
    products: `${host}goods-list`,  //列表
    detail: `${host}goods-info`,    //详情
    addShopping: `${host}add-cart`, //添加购物车
    shopping: `${host}cart-list`,   //购物车列表
    changeCount: `${host}modify-cart`,  //购物车加减
    shoppingRemove: `${host}del-cart`,  //购物车删除
    register: `${host}register`,    //注册
    login: `${host}login`,          //登录
    userinfo: `${host}user-info`,   //用户信息
    contact: `${host}contact-us`,   //联系我们
    saveOrder: `${host}save-order`, //提交订单
    pay: `${host}pay`,              //支付
    saveAddress: `${host}edit-address`, //保存地址
    orderList: `${host}order-list`, //订单列表
    orderCancel: `${host}order-cancel`, //订单取消
    editPassword: `${host}edit-password`,   //修改密码
    verifyCoupon: `${host}verify-coupon`,   //验证优惠券
    sendVerifyEmail: `${host}send-verify-email`,    //找回密码-发送邮件
    resetPassword: `${host}reset-password`,         //找回密码-修改密码
    upImage: `${host}image`,        //上传图片
    getMessage: `${host}chat`,  //客服
}